<template>

    <div class="modal fade" ref="modal" id="phoneChangeDialog" >

      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">



                <div class="modal-header dark-bg">
                  <div class="col-auto me-auto ">
                    <h3>Zmiana numeru telefonu</h3>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <button type="button" class="btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                </div>



                <div class="d-flex justify-content-center">

                  
                  <form class="mt-4 col-10">

                   


                    <div class="PopupPhone">
                      <i class="fas fa-phone"></i>




                      <input v-if="codeSent" ref="input2"  class="form-control " placeholder="Wprowadź kod sms" :class="{ 

                        'is-invalid': $v.form.code.$invalid && $v.form.code.$dirty,
                        'is-valid': !$v.form.code.$invalid && $v.form.code.$dirty 

                      }" v-model="form['code']"  @keyup.enter="doChange" @input="$v.form.code.$touch();">

                      <input v-else ref="input"  class="form-control " placeholder="Wprowadź numer" :class="{ 

                        'is-invalid': $v.form.new_phone.$invalid && $v.form.new_phone.$dirty,
                        'is-valid': !$v.form.new_phone.$invalid && $v.form.new_phone.$dirty 

                      }" v-model="form['new_phone']"  @keyup.enter="sendCode" @input="$v.form.new_phone.$touch();"> 

                       


                      <br>

                    </div>

                

                    <div class="PopupError">

<!-- 
<pre>
  {{ form }}
</pre>

<pre>
{{ $v }}
</pre> -->


                      <p v-if="$v.form.new_phone.$invalid && $v.form.new_phone.$dirty" style="color:red;" class="validatePhone">* popraw numer telefonu</p>
                      <p v-if="err" style="color:red;" class="validatePhone" v-dynamic="err"></p>

                    </div>
                  </form>
                </div>
                <div class="modal-footer d-flex justify-content-evenly">


                  <form @submit.prevent="">
                    <b-col lg="4" class="pb-2">
                      <a v-if="codeSent" class="form-button btn btn-outline-primary-o btn-lg me-2 " :class="{ disabled:$v.form.code.$invalid  }" @click="doChange" href="#" >Potwierdź</a>
                      <a v-else class="form-button btn btn-outline-primary-o btn-lg me-2 " :class="{ disabled:$v.form.new_phone.$invalid  }" @click="sendCode" href="#" >Zmień</a>
                    </b-col>
                    <!--data-bs-dismiss="modal"-->
                  </form>
                </div>

              </div>
            </div>





    </div>
        
</template>
<script>

  
  import { url, alpha, email, required, minLength, maxLength } from 'vuelidate/lib/validators';



  export default {
    
    name: 'PhoneChange',

    data() {
      return {


        form: {},

        user: {},


        err: '',


        codeSent: false,

        modal:null

      }
    },
    methods: {



      sendCode() {


        this.post( '/client/code', {
        //  client_id: parseInt(this.user.client_id),
          client_cellphone: this.form.new_phone.trim()
        } )
          .then(response => {

            if (!!response.data) {           
              if (!(response.data.IS_ERROR | 0)) {

                //this.modal.hide();

                //this.toast('Numer zmieniony!');


                this.codeSent = true;

//console.log('code sent ' + this.codeSent)

              }
            }           
          })
          .catch(error => {


            this.err = typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors;
                                
          });


      },



      doChange() {


        this.post( '/client/cellphone', {
        //  client_id: parseInt(this.user.client_id),
          client_code: this.form.code.trim(),
          client_cellphone: this.form.new_phone.trim()
        } )
          .then(response => {

            if (!!response.data) {           
              if (!(response.data.IS_ERROR | 0)) {

                this.modal.hide();


                // reload user data 
                this.echo('login_reload');

                this.toast('Numer zmieniony!');
              }
            }           
          })
          .catch(error => {


            this.err = typeof this.errors == 'object' ? Object.values(this.errors).join('<br/>') : this.errors;
                                
          });



        

      }
     
    },


    validations(){

      return {
        form: {


          code: {
            required
          },
         

          new_phone: {
            required//,
        //    minLength: minLength(9),
         //   maxLength: maxLength(9)
          },


        }
      }
    },



    created() {


      this.listen('phone_change_dialog', () => {

        this.modal.show();
      });
    },


    mounted(){



      this.user = JSON.parse(localStorage.getItem('user'));


      this.modal = new bootstrap.Modal(this.$refs['modal']);



      //console.log(this.user);
    }


  }



</script>
<style scoped>


  a.login {

    width:16rem;
  }


  .PopupPhone{
    position: relative;
  }
  .PopupPhone input {
    padding-right: 35px !important;
  }

  .PopupPhone i{
      opacity: .5;
      position: absolute;
      right: 1rem;
      padding: 17px 20px;
      pointer-events: none;
    }



  .modal-footer {
    justify-content: left;
  }




  h5 {
    justify-content: center;
  }

  .modal-dialog {
    overflow-y: initial;
    display: flex;
    justify-content: center;
    max-width:700px;
  }

  .modal-title {
    justify-content: center;
  }

  .modal-header {
    display: flex;
    justify-content: center;
    overflow-y: auto;

    text-align:center;
   
  }

  .modal-body {
    overflow-y: auto;
    display: flex;
    justify-content: center;
  }



</style>



// WEBPACK FOOTER //
// src/components/PhoneChange.vue